import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from "ol/source/Vector";
import { Cluster} from 'ol/source';
import OSM from 'ol/source/OSM';
import Feature from "ol/Feature";
import GeoJSON from 'ol/format/GeoJSON';
import Point from 'ol/geom/Point'
import { defaults as defaultInteractions } from "ol/interaction";
import {boundingExtent} from 'ol/extent.js';
import Overlay from 'ol/Overlay';
import {Style, Icon, Text, Stroke, Circle as CircleStyle, Fill} from 'ol/style';
import { fromLonLat } from 'ol/proj';
import { useEffect, useRef, useState } from 'react';
import Detail from './detail.js'
import { useNavigate } from 'react-router-dom';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { useTheme } from "@mui/material/styles";
import { Box } from '@mui/material';
import { Helmet } from "react-helmet-async";

const HelmetComponent = ({tripDetails, isDetailOpen}) => {
    if (tripDetails && !isDetailOpen) {
        if (Array.isArray(tripDetails) && tripDetails.length === 1) {
            return (
                <Helmet>
                    <title>{tripDetails[0].title}</title>
                    <meta property="og:type" content="article" />
                    <meta property="og:title" content={tripDetails[0].title} />
                    <meta property="og:description" content={tripDetails[0].description || tripDetails[0].slug} />
                    <meta property="og:url" content={`https://tripindex.in/trip/${tripDetails[0].slug}_${tripDetails[0]._id}`} />
                    <meta property="og:image" content="https://tripindex.in/fav.svg" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={tripDetails[0].title} />
                    <meta name="twitter:description" content={tripDetails[0].description || tripDetails[0].slug} />
                    <meta name="twitter:image" content="https://tripindex.in/fav.svg" />
                </Helmet>
            )
        }
        return (
            <Helmet>
                <title>Tripindex</title>
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Road Trip Map & Trails" />
                <meta property="og:description" content="Interactive map of motorbike trips, scenic routes, POIs, restaurants and stays — all personally ridden and documented."/>
                <meta property="og:url" content="https://tripindex.in/" />
                <meta property="og:image" content="https://tripindex.in/fav.svg" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Road Trip Map & Trails" />
                <meta name="twitter:description" content="Explore real raoad trips, routes, and offbeat POIs with photos." />
                <meta name="twitter:image" content="https://tripindex.in/fav.svg" />
            </Helmet>
        )
    }    
}


function MyMap({trips, selectedLoc, setSelectedLoc, isDetailOpen, setIsDetailOpen, lastSelectedLoc, selectedTrip, setSelectedTrip, tripFilter}) {
    
    const mapRef = useRef(null);
    const [map, setMap] = useState();
    const [markers, setMarkers] = useState([])
    const [zoom, setZoom] = useState(10)
    const [center, setCenter] = useState(fromLonLat([76.30132077867154, 9.981061820610766]));
    const navigate = useNavigate();

    const getAllPois = async(tripIds) => {
        const poiPromises = tripIds.map(async (tripId) => {
            const response = await fetch(`/api/trips/${tripId}/poi`)
            return await response.json()
        })
        
        const pois = await Promise.all(poiPromises)
        setMarkers(pois.flat())
    }

    useEffect(() => {

        const viewOptions = {
            center: center,
            zoom: 9,
        }

        const initialMap = new Map({
            target: mapRef.current,
            layers: [
                new TileLayer({
                    source: new OSM(),
                    name:'tile'
                }),
            ],
            view: new View(viewOptions),
            interactions: defaultInteractions({
                pinchZoom: true
            }),
        });

        setMap(initialMap);

        initialMap.getView().on('change:resolution', (event) => {
            const zoom = initialMap.getView().getZoom();
            setZoom(zoom);
        });

    },[]) 

    useEffect(()=>{
        if (lastSelectedLoc) {
            const _cord = markers.find(makrer => makrer._id === lastSelectedLoc.loc)
            if (_cord) {
                const {lat, long} = _cord.locationCords
                map.getView().setCenter(fromLonLat([long, lat]));
                map.getView().setZoom(14)  
            }
        }
        
    }, [lastSelectedLoc]) 

useEffect(()=> {
    if (map) {
        //map.getLayers().getArray().filter(layer=>layer.get('name')==='marker').forEach(layer => map.removeLayer(layer))
        map.getLayers().getArray().filter(l=>l.get('name') === 'marker' || l.get('name') === 'route').forEach(layer => map.removeLayer(layer))
        trips.forEach((trip)=> {           
            trip.route.forEach((route)=>{
                const vectorLayer = new VectorLayer({
                    name:'route',
                    source: new VectorSource({
                        url: route.file,
                        format: new GeoJSON()
                    }),
                    style: new Style({
                        stroke: new Stroke({
                            color: trip.color,
                            width: 4,
                        }),
                    }),
                });
                map.addLayer(vectorLayer);
            })            
        })
        const tripIds = trips.map(trip => trip._id)
        getAllPois(tripIds)
    }
}, [trips, map])

useEffect(()=> {
    if (map) {        

        let markerFeatures = markers.map((marker) => {
            
            if (marker.locationCords) {
                const {long, lat} = marker.locationCords
                const markerFeature = new Feature({
                    geometry: new Point(fromLonLat([long, lat])),
                    title: marker.title,
                    id:marker._id,
                    tripId:marker.tripId,
                    type: marker.type,
                    clickable: true
                });

                let iconStyle;
                let markerImg = './photo.png'
                if (marker.type === 'restaurant') {
                    markerImg = './restaurant.png'
                }
                if (marker.type === 'hotel') {
                    markerImg = './bed.png'
                }
                
                    //if (zoom >= 10) {
                iconStyle = new Style({
                    image: new Icon({
                        anchor: [0.5, 1],
                        src: markerImg,
                        scale: 0.075
                    }),
                    text: new Text({
                        text: marker.title,
                        font: '12px Arial, sans-serif',
                        offsetY: -20,
                        fill: new Fill({
                            color: 'red',
                        }),
                        stroke: new Stroke({
                            color: 'white',
                            width: 1,
                        }),
                    }),
                });
                markerFeature.setStyle(iconStyle);
                return markerFeature;
            }
        });

        markerFeatures = markerFeatures.filter(mfeature=> mfeature !== undefined)

        const markerSource = new VectorSource({
            features: markerFeatures,
        });
        

        const clusterSource = new Cluster({
            Distance: 40, // Minimum distance between clusters (in pixels)
            source: markerSource,
        });


        const clusterLayer = new VectorLayer({
            source: clusterSource,
            name:'marker',
            style: function (feature) {
                var size = feature.get('features').length;
                let style
                if (size === 1) {
                    const _feature = feature.get('features')[0].values_; 
                    let markerImg = '/marker.png'
                    if (_feature.type === 'restaurant') {
                        markerImg = '/restaurant.png'
                    }
                    if (_feature.type === 'hotel') {
                        markerImg = '/bed.png'
                    }
                    if (_feature.type === 'poi') {
                        markerImg = '/photo.png'
                    }
                    //if (zoom >= 10) {
                    style = new Style({
                        image: new Icon({
                            anchor: [0.5, 1],
                            src: markerImg,
                            scale: 0.075
                        }),
                        text: new Text({
                            text: _feature.title,
                            font: '12px Arial, sans-serif',
                            offsetY: -50,
                            fill: new Fill({
                                color: 'red',
                            }),
                            stroke: new Stroke({
                                color: 'white',
                                width: 1,
                            }),
                        }),
                    });
                } else {
                    style = new Style({
                        image: new Icon({
                            anchor: [0.5, 1],
                            src: '/cluster.png',
                            scale: 0.015
                        }),
                        text: new Text({
                            text: size.toString(),
                            offsetY: -20,
                            font: 'bold 14px Arial, sans-serif',
                            fill: new Fill({
                                color: '#000'
                            }),
                            stroke: new Stroke({
                                color: 'white',
                                width: 1,
                            }),
                        })
                    });
                }
                return style;
            },
        });
        map.addLayer(clusterLayer)
        map.on('click', (e) => {
            clusterLayer.getFeatures(e.pixel).then((clickedFeatures) => {
                if (clickedFeatures?.length) {
                // Get clustered Coordinates
                const features = clickedFeatures[0].get('features');
                if (features?.length > 1) {
                    const extent = boundingExtent(
                        features.map((r) => r.getGeometry().getCoordinates())
                    );
                    map.getView().fit(extent, {duration: 1000, padding: [50, 50, 50, 50]});
                } else {
                    const _rest = markers.find(x=>x._id === features[0].values_.id);
                    if (_rest) {
                        const path = _rest.slug ? `${_rest.slug}_${_rest._id}` : `${_rest.title.toLowerCase().replaceAll(" ", "-")}_${_rest._id}` 
                        navigate(`/poi/${path}`);
                    }
                }
                }
            });
        });
    }
}, [markers, map])
    const recenter = () => {
      map.getView().setCenter(fromLonLat([76.30132077867154, 9.981061820610766]));
      
    }

    const theme = useTheme();

    return (
        <Box>
            {tripFilter && <HelmetComponent tripDetails={trips} isDetailOpen={isDetailOpen}/>}
            <div style={{height:'calc(100dvh - 60px)', width:'100%', position:'relative', overflowY:'scroll'}}>
                <div id="map" ref={mapRef} style={{ width: '100%', height: '100%', touchAction: "pan-x pan-y" }}></div>
                {/*<div style={{width:50, backgroundColor:theme.palette.primary.main, height:50, borderRadius:25, position:'absolute', bottom:150, right:50, zInde:3, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer',}}><MyLocationIcon onClick={()=>{recenter()}} sx={{color:'white'}}/></div>*/}
            </div>
            {isDetailOpen && (<Detail
                open={isDetailOpen}
                selectedLoc={selectedLoc}
                setOpen={setIsDetailOpen}
                setSelectedLoc={setSelectedLoc}
                selectedTrip={selectedTrip}
                setSelectedTrip={setSelectedTrip}
                tripFilter={tripFilter}
            />)}
        </Box>
    );  
}

export default MyMap;
